<template>
<div>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >

        <material-card
          :color="app.color"
        >
        <v-layout wrap slot="header">
        <v-flex sm6 xs12
        >
          <span class="title">Objecten</span><br> 
          <span class="body-1">{{user.organisation.name}}</span> 
        </v-flex>
        <v-flex sm6 xs12
        >
              <v-text-field
                append-icon="mdi-magnify"
                single-line=""
                color="white"
                hide-details=""
                v-model="search"
                ></v-text-field>
            </v-flex>
        </v-layout>

      <v-tabs
        class="pt-4"
        :slider-color="app.color"
        v-model="tab">        
        <v-tab 
          v-for="(item, index) in ManagedTypes"
          :key="index"
          >
          {{item.description}}
        </v-tab>

        <v-spacer></v-spacer>
        <div class="pr-3">
          <forms-add-object v-if="ManagedTypes.length != 0" :object="ManagedTypes[tab].category"></forms-add-object>
        </div>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="(item, index) in ManagedTypes"
            :key="index"
            >
            <v-data-table
              multi-sort
              :headers="item.headers"
              :items="item.items"
              :search="search"
              :loading="app.objects.loading"  
              :footer-props="{
                itemsPerPageText: ''
              }">        
            >

              <template v-slot:no-data>
                <v-layout row justify-center="" class="pa-4">
                  Geen {{item.description}} gevonden
                </v-layout>
              </template>


              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template
                v-slot:item="props"
              >
                <tr class="selectorRow">
                  <td @click="toObject(props.item.reference)" v-for="(n,index) in item.headers" :key="index">
                    <span v-if="props.item[n.value] !== true && props.item[n.value] !== false">{{props.item[n.value]}}</span>
                    <v-icon v-if="props.item[n.value] == true" color="success">mdi-check</v-icon>
                    <v-icon v-if="props.item[n.value] == false" color="error">mdi-close</v-icon>                    
                  </td>
                  <td>
                    <v-layout>
                      <v-icon @click="showArchiveDialog({type:'object', description:props.item.name, reference:props.item.reference})" size="22" id="delete">mdi-delete</v-icon>
                    </v-layout>
                  </td>
                </tr>
              </template> 
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </material-card>

      </v-flex>
      <v-flex
        md12
      >
      </v-flex>
    </v-layout>
  </v-container>

  <dialog-delete></dialog-delete>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
  data: () => ({
    tab: 0,
    search: "",
    archived: {
      show: "",
      description: "",
      reference: ""
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10 // -1 for All
    }
  }),
  methods: {
    ...mapMutations(["showArchiveDialog"]),
    items(ref) {
      return this.$store.state.objects;
    },
    toObject(reference) {
      this.$store.dispatch("toObject", {
        reference: reference
      });
    },
    showArchive(description, reference) {
      this.archived.show = true;
      this.archived.reference = reference;
      this.archived.description = description;
    },
    archive() {
      this.$store.dispatch("deleteObject", {
        reference: this.archived.reference
      });
      this.archived.show = false;
    }
  },
  computed: {
    ...mapState(["user", "app", "createObject"]),
    ...mapGetters(["ManagedTypes"])
  },
  created() {
    this.$store.dispatch("checkAuth");
  }
};
</script>

<style scoped>
#delete {
  color: grey;
}
#delete:hover {
  color: #d3223c;
}
</style>

